import { h, render } from 'preact';
import { App } from './components/App';

console.log('[Vertex Vertices] Preact entry loading...');

// Ensure hash is set BEFORE mounting
if (!window.location.hash || window.location.hash === '#') {
  console.log('[Vertex Vertices] No hash found, setting to #/');
  window.location.hash = '/';
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  const appRoot = document.getElementById('appRoot');

  if (appRoot) {
    console.log('[Vertex Vertices] Mounting App to #appRoot');
    render(<App />, appRoot);
  } else {
    console.error('[Vertex Vertices] Mount point #appRoot not found');
  }
}
